import React, { memo } from 'react';
import { TooltipPosition } from '../../libraries/Tooltips';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './Row.scss';
const rootClassName = 'component-row';

interface RowProps extends React.HTMLAttributes<HTMLDivElement> {
  'tooltip-position'?: TooltipPosition;
  'tooltip-text'?: string;
  columnDirection?: boolean;
  centralized?: boolean;
}
function Row(props: RowProps) {
  const getProps = () => {
    const p = {
      ...props,
      className: getMergedClassNames([
        rootClassName,
        props.centralized ? 'centralized' : '',
        props.columnDirection ? 'column' : '',
        props.className,
      ]),
    } as Partial<RowProps>;

    delete p.centralized;
    delete p.columnDirection;
    return p;
  };

  return <div {...getProps()}>{props.children}</div>;
}

Row.defaultProps = {
  centralized: false,
};

export default memo(Row);
